var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"page-fade"}},[(!_vm.isLoading && _vm.logoUrl)?_c('img',{attrs:{"alt":_vm.logoAlt,"src":_vm.logoUrl,"height":"35"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }